import { Box, IconButton } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import { ReactComponent as Hamburger } from "assets/Hamburger.svg";
import ThemeContext from "components/app/Context";
import BackButton from "components/common/BackButton";
import Notifications from "components/features/Notifications";
import { useContext } from "react";
import { useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { nestedTernaryCheckerCond1 } from "utils/CommonChecker";
import Logo from "../Logo";
import UserMenu from "../UserMenu";
interface Props {
  toggleDrawer: any;
}

function TopNavbar(props: Props) {
  const { isMobileScreen } = useContext(ThemeContext);
  const isImpersonated = useAppSelector((state: any) => state.app.impersonationDetails.isImpersonated);
  const { toggleDrawer } = props;
  return (
    <AppBar
      elevation={0}
      className="app-bar"
      sx={{
        top: nestedTernaryCheckerCond1(isImpersonated, isMobileScreen, "117px", "50px", "0"),
        paddingX: "32px",
        minHeight: "76px",
        width: "100%",
        paddingLeft: isMobileScreen ? "32px" : "130px",
        justifyContent: "space-between",
        borderBottom: isMobileScreen ? `1px solid ${tokens.Border.General.Secondary}` : "none"
      }}
    >
      {isMobileScreen ? (
        <>
          <IconButton sx={{ paddingX: 0 }} onClick={toggleDrawer(true)}>
            <Hamburger />
          </IconButton>
          <Logo />
          <Box>
            <Notifications />
          </Box>
        </>
      ) : (
        <>
          <BackButton label="Back" />
          <UserMenu toggleDrawer={toggleDrawer} />
        </>
      )}
    </AppBar>
  );
}
export default TopNavbar;
